import React from 'react';
import { Shimmer } from '../../common/shimmer/shimmer';

interface VehicleImageSectionProps {
    vehicleImageUrl: string;
    vehicleName: string;
    isMobileView: boolean;
}

const VehicleImageSection: React.FC<VehicleImageSectionProps> = ({
    vehicleImageUrl,
    vehicleName,
    isMobileView,
}) => {
    const imageWidth = isMobileView ? 324 : 506;
    const imageHeight = isMobileView ? 181 : 260;

    return (
        <>
            {vehicleImageUrl ? (
                <img
                    className="fm-vehicle-image"
                    src={vehicleImageUrl}
                    alt={vehicleName}
                    crossOrigin="anonymous"
                    width={imageWidth}
                    height={imageHeight}
                    fetchpriority="high"
                    decoding="async"
                />
            ) : (
                <div className="vehicle-image-placeholder">
                    <Shimmer
                        width={`${imageWidth - 50}`}
                        height={`${imageHeight - 50}`}
                    />
                </div>
            )}
        </>
    );
};

export default VehicleImageSection;
